const isEmptyObject = function(obj) {
  if (obj !== null && typeof obj === 'object') {
    const keysArray = Object.keys(obj);
    return !(keysArray || []).length;
  }

  return true;
};

export default isEmptyObject;
